import React, { useMemo, useState } from 'react';
import EcoSpace from 'eco-design/base/eco-space';
import dynamic from 'next/dynamic';
import EcoTitle from 'eco-design/base/eco-title';
import moment from 'moment';
import { useCountDown } from 'ahooks';
import Dialog from './Dialog';
import style from './index.module.scss';
import { useLang } from '@/i18n';
import { useGlobal } from '@/utils/useGlobal';
import gtm from '@/utils/gtm';

interface Props {
    endTime: number;
}

const Countdown = dynamic(() => import('./Countdown'), {
    ssr: false, // 关键点：关闭服务端渲染
});

const EarlyBirdJP: React.FC<Props> = ({ endTime }) => {
    const { getSystemTime, useRouter } = useGlobal();
    const router = useRouter();
    const { _timer } = router.query;
    let systemTime = getSystemTime();
    const { t } = useLang('theProduct.EarlyBird');

    if (_timer) {
        systemTime = new Date(_timer).getTime();
    }

    // 倒计时
    const [, formattedRes] = useCountDown({ targetDate: endTime });

    // 邮件
    const fields = useMemo(() => {
        const date = moment(getSystemTime()).format('YYYY-MM-DD');
        return [
            { type: 'single', id: '4431', value: 1, overwrite: true },
            { type: 'single', id: '31', value: 1, overwrite: false },
            { type: 'multiple', id: '12713', value: [3], overwrite: false },
            { type: 'text', id: '12712', value: date, overwrite: false },
        ];
    }, [systemTime]);

    const list = [
        {
            title: t('item1'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1748414114156/jp-1.png',
        },
        {
            title: t('item2'),
            // pc: 'https://websiteoss.ecoflow.com/upload/image/1748414115119/jp-2.png',
            pc: 'https://websiteoss.ecoflow.com/upload/image/1749534663650/jp-2.png',
        },
    ];

    // 弹窗
    const [open, setOpen] = useState(false);

    if (systemTime >= endTime) return null;

    return (
        <div id="EarlyBird" className="EarlyBird GtmModuleData-section" data-section-id={'EarlyBird'}>
            <EcoSpace />
            <div className={style.comp}>
                <EcoTitle title={t('title')} />
                <div className="countdown-box">
                    <div className="countdown-desc">{t('desc')}</div>
                    <Countdown days={formattedRes.days} hours={formattedRes.hours} minutes={formattedRes.minutes} seconds={formattedRes.seconds} />
                </div>
                <div className="cards">
                    {list.map((i, idx) => (
                        <div className="card-item" key={idx}>
                            <img src={i.pc} alt="" />
                            <div className="card-item-title">{i.title}</div>
                        </div>
                    ))}
                </div>
                <div
                    className="tc-btn GtmModuleData-btn-text"
                    onClick={() => {
                        setOpen(true);
                        gtm.push({
                            __btn_id1: 'EarlyBird .tc-btn',
                            __btn_id2: t('footer'),
                            __btn_type: 'text',
                        });
                    }}
                >
                    {t('footer')}
                </div>
            </div>

            <Dialog open={open} onClose={() => setOpen(false)} />
        </div>
    );
};
export default EarlyBirdJP;
